import { useRef, useState } from 'react';
import { ReflexContainer } from 'react-reflex';
import { useResizeWatcher } from '@/core/hooks/useResizeWatcher.hook';
import type { ReactNode } from 'react';

type SizedReflexContainerProps = {
  children: ReactNode;
  orientation?: 'horizontal' | 'vertical';
};

/**
 * Defers mounting react-reflex until the host element has a non-zero size.
 * ReflexContainer computes pane flex values once on mount; if height is 0 at that moment the layout stays broken.
 */
export const SizedReflexContainer = ({ children, orientation = 'horizontal' }: SizedReflexContainerProps) => {
  const hostRef = useRef<HTMLDivElement>(null);
  const [hasSize, setHasSize] = useState(false);

  useResizeWatcher(
    {
      elementRef: hostRef,
      callback: ({ newHeight, newWidth }) => {
        const size = orientation === 'horizontal' ? newHeight : newWidth;
        if (size > 0) {
          setHasSize(true);
        }
      },
      callOnLoad: true,
    },
    [orientation],
  );

  return (
    <div ref={hostRef} className="flexLayoutSplitterHost">
      {hasSize && (
        <ReflexContainer orientation={orientation} windowResizeAware>
          {children}
        </ReflexContainer>
      )}
    </div>
  );
};
